import { createSlice } from "@reduxjs/toolkit";

interface PricebookPageInterface {
    loading: boolean;
}

const initialState: PricebookPageInterface = {
    loading: false,
};

const priceBookSlice = createSlice({
    name: "PriceBook",
    initialState,
    reducers: {},
});

export const PriceBookReducer = priceBookSlice.reducer;

export {
    useGetDocumentsQuery,
    useLazyGetDocumentsQuery,
} from "../../common/api/documents";
